import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportServiceView,
    GetDataFilterValuesParameters,
    GetServiceCostColumnChartResultType,
    GetServiceCostLineChartResultType,
    GetServiceCostMetricsResultType,
    GetServiceCostValuesResultType,
    ReportResultColumnDto,
    ServiceCostsClient,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ServiceCostsService extends CustomReportServiceBase<ServiceCostsClient, CustomReportServiceView> {
    constructor(protected override client: ServiceCostsClient) {
        super(client);
    }

    async getValues(parameters: GetDataFilterValuesParameters): Promise<GetServiceCostValuesResultType[]> {
        return await lastValueFrom(this.client.serviceCostsGetServiceCostValues(parameters));
    }

    async getBoxesValues(parameters: GetDataFilterValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.serviceCostsGetServiceCostBoxes(parameters));
    }

    async getColumnChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceCostColumnChartResultType[]> {
        return await lastValueFrom(this.client.serviceCostsGetServiceCostColumnChartValues(parameters));
    }

    async getMetricsValues(parameters: GetDataFilterValuesParameters): Promise<GetServiceCostMetricsResultType> {
        return await lastValueFrom(this.client.serviceCostsGetServiceCostMetricsValues(parameters));
    }

    async getLineChartValues(parameters: GetDataFilterValuesParameters): Promise<GetServiceCostLineChartResultType[]> {
        return await lastValueFrom(this.client.serviceCostsGetServiceCostLineChartValues(parameters));
    }

    override async saveCustomReport(body: CustomReportServiceView): Promise<CustomReportServiceView> {
        if (body.isPublic) return await lastValueFrom(this.client.serviceCostsSaveCatalogReport(body));
        return await lastValueFrom(this.client.serviceCostsSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.serviceCostsGetCustomReport(id));
    }

    override async shareReport(body: CustomReportServiceView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.serviceCostsCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.serviceCostsGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.serviceCostsResultAvailableColumns(organizationIds));
    }
}
